export default __webpack_public_path__ + "static/zaru_collages_v6-8-3fd744fd80fefaa7d960b99fbdc7c14b.png";